import React from 'react';
import ReactErrorBoundary from '@homeaway/react-error-boundary';
import edapWrapper from '@homeaway/edap-wrapper';
import Banner from '../Banner/Banner';
import WaypointContainer from '../WaypointContainer/WaypointContainer';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-use-before-define
BannerContainer.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    triggerFilter: PropTypes.func.isRequired,
    translations: PropTypes.object.isRequired,
    shouldThrowOnError: PropTypes.bool,
};

export default function BannerContainer({
    isMobile,
    triggerFilter,
    translations,
    shouldThrowOnError = false,
}) {
    return (
        <ReactErrorBoundary
            shouldThrowOnError={shouldThrowOnError}
            logError={(e) => {
                edapWrapper().push({
                    name: 'generic.error',
                    data: {
                        actionlocation: 'family_collection_serp_ad',
                        eventcategory: 'family collection banner',
                        eventlabel: e.message,
                    },
                });
            }}
        >
            <WaypointContainer>
                <Banner
                    isMobile={isMobile}
                    triggerFilter={triggerFilter}
                    translations={translations}
                />
            </WaypointContainer>
        </ReactErrorBoundary>
    );
}
